module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"pvPotentialHeader":"Solarstrahlung","noGisData":"Keine GIS-Daten verfügbar","dataWarningTitle":"Die Daten der Dach- und Fassadenflächen sind veraltet. Falls die Liegenschaft neu berechnet wird, besteht die Möglichkeit, dass Fassadenflächen fälschlicherweise nicht berücksichtigt werden. Um dies zu beheben fragen Sie sie hier neu ab."}}')
  delete Component.options._Ctor
}
